import { z } from 'zod/v4'
import { baseModelSchema } from '../../libs/base-model.ts'

export const projectInventoryItemModelSchema = baseModelSchema.extend({
  projectId: z.string(),
  inventoryItemId: z.string(),
  imageUrl: z.string().optional().nullable(),
  quantity: z.number(),
  originalPriceCents: z.number(),
  priceCents: z.number().optional().nullable(),
  sortOrder: z.number(),
})
export type ProjectInventoryItemModel = z.infer<typeof projectInventoryItemModelSchema>

export const projectInventoryItemBulkAddSchema = z.object({
  items: z.array(
    z.object({
      inventoryItemId: z.string(),
      quantity: z.number().int().positive().default(1),
    }),
  ),
})
export type ProjectInventoryItemBulkAdd = z.infer<typeof projectInventoryItemBulkAddSchema>

export const projectInventoryItemUpdateSchema = z.object({
  quantity: z.number().optional(),
  priceCents: z.number().optional(),
  sortOrder: z.number().optional(),
})
export type ProjectInventoryItemUpdate = z.infer<typeof projectInventoryItemUpdateSchema>

export const projectInventoryItemSortOrderMapSchema = z.record(
  z.uuid().meta({ description: 'The id of the project inventory item' }),
  z.int().meta({ description: 'The sort order of the project inventory item' }),
)
export type ProjectInventoryItemSortOrderMap = z.infer<
  typeof projectInventoryItemSortOrderMapSchema
>

export const projectInventoryItemUpdateSortOrderSchema = z.object({
  orderMap: projectInventoryItemSortOrderMapSchema,
})
export type ProjectInventoryItemUpdateSortOrder = z.infer<
  typeof projectInventoryItemUpdateSortOrderSchema
>
